import * as React from 'react';
import { PVASelectOption } from '../../../components';
import { FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import './PVASelect.css';

interface PVAGenericMultiSelectProps {
    defaultOptions?: any[];
    options: PVASelectOption[];
    selected: number[];
    onChange: Function;
    FilterStore?: FilterStore;
}

interface PVAGenericMultiSelectState {
    isOpen: boolean;
}

@inject('FilterStore') @observer
export class PVAGenericMultiSelect extends React.Component<PVAGenericMultiSelectProps, PVAGenericMultiSelectState> {
    constructor(props: PVAGenericMultiSelectProps) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }
    
    private optChange(userId: number) {
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    value: userId
                }
            });
        }
    }

    render() {

        return (
            <div className="pva-select-box multi">
                <div className={`pva-select-box-selected ${this.state.isOpen ? 'open' : ''}`} onClick={(e) => this.setState({ isOpen: !this.state.isOpen })}>
                    <div className="user-row">
                        <span>{this.props.selected.length} Selected</span>
                    </div>
                    <div className="pva-select-box-toggle">
                        {!this.state.isOpen && <span className="glyphicon glyphicon-triangle-bottom" />}
                        {this.state.isOpen && <span className="glyphicon glyphicon-triangle-top" />}
                    </div>
                </div>
                {this.state.isOpen &&
                    <div className="pva-select-box-options">
                        {this.props.defaultOptions && this.props.defaultOptions.map((o: any, ind: number) => {
                            return <div key={`select-default-opt-${ind}`} className="user-row" onClick={(e) => this.optChange(o.id)}>
                                <div className="user-name"><span>{o.value}</span></div>
                            </div>;
                        })}                        
                        {this.props.options.map((data: PVASelectOption, index: number) => {
                            return <div key={`select-opt-${data.id}`} className="user-row" onClick={(e) => this.optChange(data.id)}>
                                <div className="user-checkbox">
                                    <div className={`pva-checkbox ${this.props.selected.indexOf(data.id) > -1 ? 'checked' : ''}`}>
                                        <div className="checkbox-inner" />
                                    </div>
                                </div>
                                <div className="user-name"><span>{data.label}</span></div>
                            </div>;
                        })}
                    </div>}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAGenericMultiSelect.tsx